import { FreewheelParameterType } from 'tag/ts/tag/ads/freewheel/enums/FreewheelParameterType';
import { AbstractFreewheelParameter } from 'tag/ts/tag/ads/freewheel/parameters/AbstractFreewheelParameter';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Represents a parameter within a Freewheel request whose value is set from Frequency Management Service (FMS)
 */
export class FmsParameter extends AbstractFreewheelParameter {
	constructor( key: string, value: string ) {
		super( {
			key: key,
			value: value,
			type: FreewheelParameterType.CUSTOM,
			name: `FMS Parameter--${key}`
		} );
	}
}